/* Flagpost — De la jugada al bordado: rotación automática + pestañas */
(() => {
  if (customElements.get('flagpost-plays')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class FlagpostPlays extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.fp-plays__tab')];
      this.slides = [...this.querySelectorAll('.fp-plays__slide')];
      this.interval = Number(this.dataset.interval) || 7000;
      this.style.setProperty('--fp-plays-interval', `${this.interval}ms`);
      this.active = 0;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => { this.show(i, true); });
        tab.addEventListener('keydown', (e) => {
          const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (!dir) return;
          e.preventDefault();
          const next = (this.active + dir + this.tabs.length) % this.tabs.length;
          this.show(next, true);
          this.tabs[next].focus();
        });
      });

      // Pausa mientras el cliente mira o interactúa
      ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => this.pause()));
      ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.resume()));

      // Solo rota cuando la sección está en pantalla
      this.visible = false;
      new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.visible ? this.resume() : this.pause();
      }, { threshold: 0.35 }).observe(this);
    }

    show(i, user = false) {
      if (!this.slides[i]) return;
      this.active = i;
      this.tabs.forEach((t, k) => {
        const on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.resetBar();
      this.slides.forEach((s, k) => {
        s.hidden = k !== i;
        s.classList.toggle('is-active', k === i);
      });
      if (user) this.restart();
    }

    // Reinicia la barrita de progreso de la pestaña activa (va sincronizada con el timer)
    resetBar() {
      const bar = this.tabs[this.active]?.querySelector('.fp-plays__progress');
      if (!bar) return;
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }

    restart() {
      clearTimeout(this.timer);
      if (this.paused || !this.visible || reduceMotion.matches || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        this.show((this.active + 1) % this.slides.length);
        this.restart();
      }, this.interval);
    }

    pause() {
      this.paused = true;
      this.classList.add('is-paused');
      clearTimeout(this.timer);
    }

    resume() {
      if (!this.visible || this.contains(document.activeElement) || this.matches(':hover')) return;
      this.paused = false;
      this.classList.remove('is-paused');
      this.resetBar();
      this.restart();
    }
  }

  customElements.define('flagpost-plays', FlagpostPlays);
})();
